import { FormSection } from 'framework/ui/layout';
import { SuccessMessage, useMessageService } from 'framework/ui/Message';
import useLeadReportService, { PERIOD_TYPES } from 'domain/sales/report/useLeadReportService';
import { EnumDropdown, ModalFormButton } from 'framework/form';
import { useListContext } from 'framework/list';

const RequestLeadReportButton = () => {
  const { addMessage } = useMessageService();
  const { create } = useLeadReportService();
  const { reloadData } = useListContext();

  return (
    <ModalFormButton
      outline
      formTitle="Request report generation"
      label="Request report generation"
      submitFormFunc={formState => create(formState)}
      initialData={{
        periodType: 'LAST_MONTH', // Default value for periodType
      }}
      afterSubmit={{
        execute: () => {
          addMessage(new SuccessMessage('The lead report has been requested successfully.'));
          if (reloadData) {
            reloadData();
          }
        },
      }}
    >
      <FormSection>
        <EnumDropdown options={PERIOD_TYPES} source="periodType" label="Period type" />
      </FormSection>
    </ModalFormButton>
  );
};

export default RequestLeadReportButton;
